import api from "../../api/axios";
import { API_ENDPOINTS } from "../../api/endpoints";
import type {
  AuthUser,
  LoginApiPayload,
  RefreshTokenResponse,
} from "./types";

export const authApi = {
  login: async ({ userName, password }: LoginApiPayload): Promise<AuthUser> => {
    const response = await api.post<AuthUser>(API_ENDPOINTS.AUTH.LOGIN, {
      userId: userName,
      password,
    });
    return response.data;
  },

  refreshToken: async (): Promise<RefreshTokenResponse> => {
    const response = await api.post<RefreshTokenResponse>(API_ENDPOINTS.AUTH.REFRESH_TOKEN);
    return response.data;
  },
};

export default authApi;
